The event signaling that a `CandidateProfile` has been purchased.
